// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1c1ccece","239":"26fc3f9e","667":"b5e248f9"}[chunkId] + ".chunk.js";
};